import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import AnimationForm from '../common/animationForm';
import {TABS} from '../../form/part/tabs';
import SlideChange from '../common/slideChange';
import {IElementHtml} from '../../../../incase-domain/elements/html';
import HtmlEditorModal from './HtmlEditorModal';
import {showHtmlCodeEditorModal} from '../../../../store/selectors/html.selectors';
import {useHighlightedElement, useSetHighlightedElement} from '../../../../utils/hooks/slideUpdates/useSetSlideElement';

interface HighlightedHtmlElementComponentProps {
    overrideHighlightedElement?: IElementHtml;
    overrideHighlightedElementChangeHandler?: {single: (field: keyof IElementHtml, value: unknown) => void};
    isFlipCard?: boolean;
    activeTab: string;
}

HighlightedHtmlElementComponent.defaultProps = {
    isFlipCard: false,
};

function HighlightedHtmlElementComponent(props: HighlightedHtmlElementComponentProps): ReactElement {
    const {overrideHighlightedElement, overrideHighlightedElementChangeHandler, isFlipCard, activeTab} = props;
    const openHtmlEditor = useSelector(showHtmlCodeEditorModal);
    const updateHighlightedElement = useSetHighlightedElement();
    const highlightedElement = useHighlightedElement() as IElementHtml;
    const element = overrideHighlightedElement || highlightedElement;

    const changeHandler = overrideHighlightedElementChangeHandler || updateHighlightedElement;

    const {t} = useTranslation();

    if (activeTab === TABS.ADVANCED.id) {
        return (
            <>
                {!isFlipCard && (
                    <div className="l-group--form">
                        <div className="l-group__item">
                            <div className="u-mb-1">{t('designSidepanel.slideChangeOnClick')}</div>
                            <SlideChange
                                slideChange={element.slideChange}
                                setSlideChange={(slideChange) => {
                                    changeHandler.single('slideChange', slideChange);
                                }}
                            />
                        </div>
                    </div>
                )}
            </>
        );
    }

    return (
        <>
            <AnimationForm
                appearAfter={element.appearAfter || 0}
                elementAnimations={element.elementAnimations}
                highlightedElementChangeHandler={changeHandler}
            />

            {openHtmlEditor && <HtmlEditorModal element={element} highlightedElementChangeHandler={changeHandler} />}
        </>
    );
}

export default HighlightedHtmlElementComponent;
